import React, { useState } from 'react';
import { REENGAGE_OPTIONS, setReengage } from '../../services/crmService';
import { ui } from './crmUi';

// Asked after a "Not ready" call result.
export default function ReengageModal({ contact, uid, isAdmin, onDone }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [date, setDate] = useState('');
  const today = new Date(); const minDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate() + 0).padStart(2, '0')}`;
  if (!contact) return null;
  const pick = async (label, months) => {
    setBusy(true);
    try { await setReengage(contact, label, months, uid, isAdmin); onDone(); } catch (e) { setErr(e.message || 'Could not save.'); setBusy(false); }
  };
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(20, 24, 33, 0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 1100 }}>
      <div role="dialog" aria-modal="true" style={{ background: '#FFFFFF', borderRadius: 12, padding: 24, width: '100%', maxWidth: 420, boxShadow: '0 12px 40px rgba(0,0,0,0.25)', boxSizing: 'border-box' }}>
        <h3 style={ui.sectionTitle}>When would you like to re-engage?</h3>
        <p style={ui.sub}>{[contact.firstName, contact.lastName].filter(Boolean).join(' ') || contact.name}. A follow-up task goes to the assigned agent on that date.</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 8 }}>
          {REENGAGE_OPTIONS.map(([label, months]) => (
            <button key={label} disabled={busy} style={months == null ? ui.ghost : ui.btn} onClick={() => pick(label, months)}>{label.replace(/^in /, '')}</button>
          ))}
        </div>
        <label style={ui.label}>Or pick a date</label>
        <div style={ui.row}>
          <input type="date" style={{ ...ui.input, flex: 1, width: 'auto' }} min={minDate} value={date} onChange={(e) => setDate(e.target.value)} />
          <button style={ui.btn} disabled={busy || !date || date <= minDate} onClick={() => pick(`until ${new Date(`${date}T12:00:00`).toLocaleDateString()}`, date)}>Set date</button>
        </div>
        {err && <div style={{ color: '#D64545', fontSize: 13, marginTop: 8 }}>{err}</div>}
        <button style={{ ...ui.ghost, marginTop: 12 }} disabled={busy} onClick={onDone}>Skip</button>
      </div>
    </div>
  );
}
